import { useState, useEffect } from "react";
import { Button, Icon, Label, Popup, Form as FormSuir, Input as InputSuir } from "semantic-ui-react";
import { Row, Col, Form, InputGroup, Offcanvas } from "react-bootstrap";
import { TwitterPicker } from "react-color";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'

const ProductFilterClearance = ({
    setProducts,
    categoryId,
    categoryFrom,
    colorList,
    brandList,
    sizeList,
    doGetProduct,
    originalData,
    onFilterChange,

    // NEW
    searchVal,
    setSearchVal,
    handleSearch
    }) => {

    const [prodName, setProdName] = useState('')
    const [priceMin, setPriceMin] = useState(0)
    const [priceMax, setPriceMax] = useState(5000000)
    const [mainColors, setMainColors] = useState([])
    const [showPicker, setShowPicker] = useState(false)
    const [selColor, setSelColor] = useState('')
    const [loading, setLoading] = useState(false)
    const [btnDisable, setbtnDisable] = useState(false)
    const [brand, setBrand] = useState(0)
    const [size, setSize] = useState(0)
    const [canvasShow, setCanvasShow] = useState(false)

    //const [sortBy, setSortBy] = useState('')
    const [sortBy, setSortBy] = useState({
        recommended: true,
        price: null, // 'asc' | 'desc'
        on_sale: false
    })
    //const [rawData, setRawData] = useState([])

    // ✅ NEW: responsive detection
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 992);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const styles = {
        color: {
            width: '36px',
            height: '16px',
            borderRadius: '2px',
            background: `${selColor}`,
        },
        swatch: {
            padding: '8.5px',
            background: '#fff',
            borderRadius: '3px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.2)',
            display: 'inline-flex',
            cursor: 'pointer',
        },
        popover: {
            position: 'absolute',
            zIndex: '2',
        },
        cover: {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
        },
    }

    const handleClick = (e) => {
        e.preventDefault()
        setShowPicker(!showPicker)
    }

    const handleClose = () => (setShowPicker(false))

    const handleChange = (color) => (setSelColor(color.hex))

    const handleBrandChange = (e) => setBrand(e.target.value)
    const handleSizeChange = (e) => setSize(e.target.value)

    const handleClear = () => {
        const reset = {
            brand: null,
            size: null,
            color: null,
            priceMin: null,
            priceMax: null,
            keyword: '',
            sortBy: {
                recommended: true,
                price: null,
                on_sale: false
            }
        }

        setBrand(0)
        setSize(0)
        setProdName('')
        setSelColor('')
        setPriceMin(0)
        setPriceMax(5000000)

        onFilterChange(reset)

        window.scrollTo(0, 0)
    }

    const colorOpt = (colors) => {
        let arr = []
        colors.map(i => (arr.indexOf(i.color_main) === -1) ? arr.push(i.color_main) : false)
        setMainColors(arr)
    }

    const handleCloseCanvas = () => setCanvasShow(false)
    const handleClickCanvas = () => setCanvasShow(!canvasShow)

    const toggleSort = (key, value = null) => {
        setSortBy(prev => {
            if (key === 'recommended') {
                setPriceMin(0)
                setPriceMax(5000000)
                return {
                    recommended: true,
                    price: null,
                    on_sale: false
                }
            }

            if (key === 'price') {
                return {
                    recommended: false,
                    price: value,
                    on_sale: false
                }
            }

            if (key === 'on_sale') {
                return {
                    recommended: false,
                    price: null,
                    on_sale: !prev.on_sale
                }
            }

            return prev
        })
    }

    useEffect(() => {
        if (colorList && colorList.length > 0) {
            const uniqueColors = []

            colorList.forEach(i => {
                if (!uniqueColors.includes(i.color_main)) {
                    uniqueColors.push(i.color_main)
                }
            })

            setMainColors(uniqueColors)
        }
    }, [colorList])

    useEffect(() => {
        onFilterChange({
            brand,
            size,
            color: selColor,
            priceMin,
            priceMax,
            keyword: prodName,
            sortBy
        })
    }, [sortBy])

    // ✅ Extracted form
    const renderForm = () => (
        <>
        <div>
            <h3 className="mb-3 text-bold">Sort</h3>
            <Row>
                <Col xl={12} className="mb-2">
                    <Button
                        content="New Arrival"
                        className={`sort-button active`}
                        color={`${sortBy.recommended ? 'teal' : ''}`}
                        onClick={() => toggleSort('recommended')}
                    />
                </Col>
                
                <Col className="col-12 mb-2">
                    <Button
                        content="On Sale"
                        className={`sort-button active`}
                        color={`${sortBy.on_sale ? 'teal' : ''}`}
                        onClick={() => toggleSort('on_sale')}
                    />
                </Col>

                <Col className="col-12">
                    <Form.Select
                        value={sortBy.price || ''}
                        onChange={(e) => toggleSort('price', e.target.value)}
                        className={`sort-dropdown ${sortBy.price ? 'active' : ''}`}
                    >
                        <option value="" disabled>Sort by price...</option>
                        <option value="asc">Price: Low to High</option>
                        <option value="desc">Price: High to Low</option>
                    </Form.Select>
                </Col>
                
            </Row>
        </div>
        
        <hr className="hr" style={{margin: "2rem 0px 2rem 0px"}}/>

        <Form onSubmit={(e) => {
            e.preventDefault()

            onFilterChange({
                brand,
                size,
                color: selColor,
                priceMin,
                priceMax,
                keyword: prodName,
                sortBy
            })
        }}>
            <h3 className="mb-3 text-bold">Filter</h3>
            <Row>
                <Col xl={12} className="mb-3">
                    <Form.Label className="fw-bold">Brand</Form.Label>
                    <Form.Select onChange={handleBrandChange}>
                        <option value={0}>Select...</option>
                        {
                            brandList.map((item, i) => {
                                const words = item.category_name.split(' ')
                                const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())

                                return (
                                    <option key={i} value={item.id_category}>{capitalizedWords.join(' ')}</option>
                                )
                            })
                        }
                    </Form.Select>
                </Col>
                <Col xl={12} className="mb-3">
                    <Form.Label className="fw-bold">Size</Form.Label>
                    <Form.Select onChange={handleSizeChange}>
                        <option value={0}>Select...</option>
                        {
                            sizeList.map((item, i) => (
                                <option key={i} value={item}>{item}</option>
                            ))
                        }
                    </Form.Select>
                </Col>
                <Col xl={12} className="mb-3">
                    <div className="mb-2 fw-bold">Color</div>
                    <InputGroup>
                        <div style={styles.swatch} >
                            <div style={styles.color} onClick={(e) => handleClick(e)} />
                            {
                                (selColor !== '') ?
                                    <FontAwesomeIcon icon={faClose} className="ms-2" onClick={() => setSelColor('')} />
                                    : <></>
                            }
                        </div>

                    </InputGroup>
                    {showPicker ?
                        <div style={styles.popover}>
                            <div style={styles.cover} onClick={handleClose} />
                            <TwitterPicker colors={mainColors} color={selColor} onChange={handleChange} onChangeComplete={handleClose} />
                        </div> : null}
                </Col>
                <Col xl={12} className="mb-3">
                    <Form.Label className="fw-bold">Price Range (Rp)</Form.Label>
                    {/*
                    <InputGroup>
                        <InputGroup.Text>From</InputGroup.Text>
                        <Form.Control type="text" value={priceMin} minLength={0} onChange={(e) => setPriceMin(e.target.value)} placeholder="Min" />
                        <InputGroup.Text>To</InputGroup.Text>
                        <Form.Control type="text" value={priceMax} maxLength={5000000} onChange={(e) => setPriceMax(e.target.value)} placeholder="Max" />
                    </InputGroup> */}
                    <div className="mb-2">
                        <div className="d-flex justify-content-between">
                            <span>Rp {Number(priceMin).toLocaleString()}</span>
                            <span>Rp {Number(priceMax).toLocaleString()} ++</span>
                        </div>
                    </div>

                    <Slider
                        range
                        min={0}
                        max={5000000}
                        step={50000}
                        value={[priceMin || 0, priceMax || 5000000]}
                        onChange={(value) => {
                            setPriceMin(value[0])
                            setPriceMax(value[1])
                        }}
                        handleStyle={[{ borderColor: 'teal' }, { borderColor: 'teal' }]}
                        trackStyle={[{ backgroundColor: 'teal' }]}
                    />
                </Col>
                <Col xl={12} className="d-flex justify-content-end align-self-end mb-3 mt-3">
                    <Button.Group floated="Left" fluid>
                        <Button content="Apply" icon="filter" type="submit" loading={loading} disabled={btnDisable} color="teal" />
                        <Button content="Clear" type="reset" icon="retweet" onClick={() => handleClear()} disabled={btnDisable} color="black" />
                    </Button.Group>
                </Col>
            </Row>
        </Form>
        </>
    )

    /*
    useEffect(() => {
        setProducts(prev => applySort([...prev], sortBy))
    }, [sortBy])
    */
   /*
    useEffect(() => {
        if (sortBy.recommended) {
            // 🔥 balik ke data awal
            setProducts([...rawData])
        } else {
            setProducts(prev => applySort([...prev], sortBy))
        }
    }, [sortBy])
    
    useEffect(() => {
        if (sortBy.recommended) {
            if (rawData.length > 0) {
                setProducts([...rawData])
            }
            return
        }

        setProducts(prev => applySort([...prev], sortBy))
    }, [sortBy])
    */
    

    return (
        <section>

            {isMobile ? (
                <>
                    <div className="row" style={{top: '60px'}}>
                        <div className="col-6">
                            <Button
                                className="w-100"
                                content="Sort & Filter"
                                icon="filter"
                                onClick={handleClickCanvas}
                                basic color="black" 
                                style={{paddingLeft: '0', paddingRight: '0'}}
                            />
                        </div>
                        
                        <div className="col-6">
                            <FormSuir onSubmit={handleSearch}>
                                <Popup
                                    trigger={
                                        <InputSuir
                                            fluid
                                            value={searchVal}
                                            onChange={(e) => setSearchVal(e.target.value)}
                                            icon={{ name: "search", link: true }}
                                            placeholder="Search"
                                        />
                                    }
                                    content="Type Name or Article and then press Enter"
                                />
                            </FormSuir>
                        </div>
                    </div>

                {/*
                    <Row className="mb-3">
                        <Col xs={5}>
                            <Button
                                className="w-100"
                                content="Filter"
                                icon="filter"
                                onClick={handleClickCanvas}
                            />
                        </Col>

                        <Col xs={7}>
                            <FormSuir onSubmit={handleSearch}>
                                <Popup
                                    trigger={
                                        <InputSuir
                                            fluid
                                            value={searchVal}
                                            onChange={(e) => setSearchVal(e.target.value)}
                                            icon={{ name: "search", link: true }}
                                            placeholder="Search"
                                        />
                                    }
                                    content="Type Name or Article and then press Enter"
                                />
                            </FormSuir>
                        </Col>
                    </Row>
                */}

                    <Offcanvas show={canvasShow} onHide={handleCloseCanvas}>
                        {/*
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title className="mb-3">Filter</Offcanvas.Title>
                        </Offcanvas.Header>
                        */}
                        <Offcanvas.Header>
                            <Offcanvas.Title></Offcanvas.Title>
                            <Icon name="close" onClick={handleClickCanvas} size="large" style={{cursor:'pointer'}}/>
                        </Offcanvas.Header>

                        <Offcanvas.Body className="inner-filter-sidebar-2">
                            {renderForm()}
                        </Offcanvas.Body>
                    </Offcanvas>
                </>
            ) : (
                <div className="p-3 border rounded bg-white d-flex">
                    <div className="w-100 text-start" style={{ maxWidth: "320px"}}>
                        {/*<h3 className="mb-4 text-bold">Filter</h3>*/}
                        {renderForm()}
                    </div>
                </div>
            )}

        </section>
    )
}

export default ProductFilterClearance;